import React,{useEffect, useState} from "react";
import { Row, Col, Container } from "olive-react-myoneui";
import NavigationBarStudentLanding from "../../components/NavigationBarStudentLanding";
import TopHeader from "../../components/TopHeader";
import Footer from "../../components/Footer";
import EnquiryForm from "../../components/EnquiryForm";
import ThankYouModal from "../../components/student-dashboard/ThankYouModal";

function EnquiryFormPage() {
  const [showSuccessSnack, setShowSuccessSnack]           = useState(false);
  const [enquirySuccessTitle, setEnquirySuccessTitle]     = useState('');
  const [enquirySuccessMessage, setEnquirySuccessMessage] = useState('Thank you for you message, You’ll be hearing from us soon');
  const [modalThankYouShow, setModalThankYouShow]         = useState(false);

  const fromEnquiryPage = true;
  useEffect(() => {
    
  })
  return (
    <>
      <TopHeader />
      <NavigationBarStudentLanding />
      <div style={{margin:'70px 10px'}}>
        <Container>
          <Row>
            <Col lg={6}>
              <EnquiryForm setModalThankYouShow={setModalThankYouShow} fromEnquiryPage={fromEnquiryPage} setShowSuccessSnack={setShowSuccessSnack} setEnquirySuccessTitle={setEnquirySuccessTitle} setEnquirySuccessMessage={setEnquirySuccessMessage}/>
            </Col>
          </Row>
        </Container>
      </div>
      <ThankYouModal
        show={modalThankYouShow}
        onHide={() => setModalThankYouShow(false)}
        successTitle={enquirySuccessTitle}
        successMessage={enquirySuccessMessage}
      />
      <Footer />
    </>
  );
}

export default EnquiryFormPage;
